<template>
  <b-card class="border-bottom border-top border-2">
    <b-row>
      <b-col sm="4">
        <b-form-group label="เดิมพันสูงสุดต่อเลข วิ่งบน">
          <b-form-input
            :value="items.U1MaxLimit"
            type="number"
            disabled
          />
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <b-form-group label="จ่าย วิ่งบน">
          <b-form-input
            :value="items.U1Pay"
            type="number"
            disabled
          />
        </b-form-group>
      </b-col>

      <b-col sm="4">
        <b-form-group label="จ่ายสูงสุด วิ่งบน">
          <b-form-input
            :value="items.U1MaxLimit * items.U1Pay"
            type="number"
            disabled
          />
        </b-form-group>
      </b-col>
      <b-col sm="6">
        <b-form-group
          label="เดิมพันต่ำสุดต่อรอบ/เลข วิ่งบน"
          disabled
        >
          <b-form-input
            :value="items.U1MinBet"
            type="number"
          />
        </b-form-group>
      </b-col>
      <b-col sm="6">
        <b-form-group label="เดิมพันสูงสุดต่อรอบ/เลข วิ่งบน">
          <b-form-input
            :value="items.U1MaxBet"
            type="number"
            disabled
          />
        </b-form-group>
      </b-col>
    </b-row>

    <b-collapse
      :visible="isCollapsed"
    >
      <b-row
        class="d-flex justify-content-center align-items-center text-center p-1"
      >
        <b-col sm="4">
          <b-form-group label="เดิมพันสูงสุดต่อเลข วิ่งบน">
            <b-form-input
              :value="items.U1MaxLimit"
              disabled
              type="number"
            />
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group label="ระดับ">
            <b-form-select
              v-model="items.U1StepPay.length"
              :options="optionslevel"
              disabled
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row
        v-for="(lv, idx) in items.U1StepPay"
        :key="idx"
        :visible="isCollapsed"
        class="d-flex justify-content-center align-items-end px-1"
      >
        <b-col sm="2">
          <b-form-group>
            <b-button
              block
              variant="outline-primary"
              style="cursor: default"
            >ระดับ {{ idx + 1 }}</b-button></b-form-group>
        </b-col>
        <b-col sm="2">
          <b-form-group :label="idx === 0 ? 'ระดับอัตราจ่าย' : ''">
            <b-form-input
              :value="lv"
              type="number"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col sm="2">
          <b-form-group :label="idx === 0 ? 'เปอร์เซ็นต์อัตราจ่าย' : ''">
            <b-form-select
              :value="items.U1StepPct[idx]"
              :options="percentageOptions"
              disabled
            />
          </b-form-group>
        </b-col>
        <b-col sm="2">
          <b-form-group :label="idx === 0 ? 'รวม' : ''">
            <b-form-input
              :value="(items.U1MaxLimit * items.U1StepPct[idx]) / 100"
              type="number"
              disabled
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-collapse>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BButton,
  BFormInput,
  BCard,
  BFormSelect,
  BCollapse,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BButton,
    BFormInput,
    BCard,
    BFormSelect,
    BCollapse,
  },
  props: ['isCollapsed', 'items'],
  data() {
    return {
      optionslevel: [
        { value: 1, text: '1' },
        { value: 2, text: '2' },
        { value: 3, text: '3' },
        { value: 4, text: '4' },
        { value: 5, text: '5' },
        { value: 6, text: '6' },
        { value: 7, text: '7' },
        { value: 8, text: '8' },
        { value: 9, text: '9' },
        { value: 10, text: '10' },
      ],
      percentageOptions: [
        { value: 100, text: 100 },
        { value: 95, text: 95 },
        { value: 90, text: 90 },
        { value: 85, text: 85 },
        { value: 80, text: 80 },
        { value: 75, text: 75 },
        { value: 70, text: 70 },
        { value: 65, text: 65 },
        { value: 60, text: 60 },
        { value: 55, text: 55 },
        { value: 50, text: 50 },
        { value: 45, text: 45 },
        { value: 40, text: 40 },
        { value: 35, text: 35 },
        { value: 30, text: 30 },
        { value: 25, text: 25 },
        { value: 20, text: 20 },
        { value: 15, text: 15 },
        { value: 10, text: 10 },
        { value: 5, text: 5 },
        { value: 0, text: 0 },
      ],
    }
  },
  computed: {},
  methods: {},
}
</script>

<style lang="scss"></style>
